import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RecipientOrganizationModel } from 'core/models/recipient.model';

@Injectable({
    providedIn: 'root',
})
export class RoleStorageService {
    public static roleKey = 'roles';
    public static moduleKey = 'modules';
    public static recipientKey = 'recipients';
    public static currentRecipientKey = 'currentRecipientKey';
    constructor(public router: Router) {}

    public getValue() {
        if (localStorage.getItem('role')) {
            localStorage.clear();
            this.router.navigate(['auth', 'login']);
        } else {
            return localStorage
                .getItem(RoleStorageService.roleKey)
                ?.split(',')
                .map(role => +role);
        }
    }

    public setValue(value: string) {
        localStorage[RoleStorageService.roleKey] = value;
    }

    public setValueModules(value: string) {
        localStorage[RoleStorageService.moduleKey] = value;
    }

    public setValueRecipients(value: RecipientOrganizationModel[]) {
        localStorage[RoleStorageService.recipientKey] = JSON.stringify(value);
    }

    public setValueCurrentRecipient(value: RecipientOrganizationModel) {
        localStorage[RoleStorageService.currentRecipientKey] = JSON.stringify(value);
    }

    public getModulesValue() {
        return localStorage
            .getItem(RoleStorageService.moduleKey)
            ?.split(',')
            .map(role => +role);
    }

    public getReceptionsValue(): RecipientOrganizationModel[] {
        return JSON.parse(
            localStorage.getItem(RoleStorageService.recipientKey) ?? '[]',
        ) as RecipientOrganizationModel[];
    }

    public getCurrentRecipientValue(): RecipientOrganizationModel {
        return localStorage.getItem(RoleStorageService.currentRecipientKey)
            ? (JSON.parse(
                  localStorage.getItem(RoleStorageService.currentRecipientKey),
              ) as RecipientOrganizationModel)
            : null;
    }

    public removeRecipientValue() {
        localStorage.removeItem(RoleStorageService.recipientKey);
        localStorage.removeItem(RoleStorageService.currentRecipientKey);
    }

    public removeValue() {
        localStorage.removeItem(RoleStorageService.roleKey);
    }
}
